import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/reminders`;
const hdr = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("admin_token") || ""}` } });

export const remindersApi = {
  list: (includeDone = false) => axios.get(API, { params: { include_done: includeDone }, ...hdr() }).then((r) => r.data),
  create: (body) => axios.post(API, body, hdr()).then((r) => r.data),
  patch: (id, body) => axios.patch(`${API}/${id}`, body, hdr()).then((r) => r.data),
  remove: (id) => axios.delete(`${API}/${id}`, hdr()).then((r) => r.data),
};

export const fmtDue = (r) => {
  const d = new Date(`${r.due_date}T12:00:00`);
  const day = d.toLocaleDateString("it-IT", { weekday: "short", day: "numeric", month: "short" });
  return r.due_time && r.due_time !== "09:00" ? `${day} · ${r.due_time}` : day;
};
